import { Component, Input } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { CommonModule, NgClass, NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
  selector: 'ra-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLinkWithHref, NgSwitchCase, NgSwitch, NgClass],
})
export class TitleComponent {
  // Использовать в случае, если хотим отобразить лого где-то в сервисе (на мобилках название обрезается)
  @Input() removeMedia: boolean = false;
  @Input() removePaddings: boolean = false;
  @Input() isDemo: boolean = false;
}
